<template>
    <v-spacer class="spacing-h-60-32 back-blue"/>
    <v-container fluid class="back-blue h-300-500 flex-center-x pa-0 ma-0">
        <!-- PC版 -->
        <div class="max-w-1200-388" style="width: 100%;" v-if="!isSm">
            <v-row>
                <v-col>
                    <div>
                        <a href="#" @click.prevent="goToTopPage">
                            <img :src="require('@/assets/kaeru.svg')" class="w-320-320"/>
                        </a>
                        <v-spacer class="spacing-h-20-32"/>
                        <div class="footer-links flex-start-x font-14-14">
                            <a href="/terms" class="footer-link">利用規約</a>
                            <a href="/conditions" class="footer-link">試算条件</a>
                        </div>
                    </div>
                </v-col>
                <v-col class="flex-end-x">
                    <a href="https://uchikara-setagaya.com/?utm_source=simulation&utm_medium=internal&utm_campaign=cpweb" rel="noopener noreferrer" target="_blank">
                        <img class="md-h-140 sm-h-24" :src="require('@/assets/footer/uchikaraFooter.svg')" />
                    </a>
                    <div class="mr-7"></div>
                    <div class="font-16-12">
                        <p>家庭の脱炭素化を</p>
                        <p>支援する</p>
                        <p>補助金・助成制度を</p>
                        <p>ご紹介しています。</p>
                    </div>
                </v-col>
            </v-row>
            <v-spacer class="spacing-h-46-46"/>
            <v-row class="font-14-10 text-center">
                ©UCHIKARA All Rights Reserved.
            </v-row>
            <v-spacer class="spacing-h-24-24"/>
            <v-spacer class="spacing-h-80-80" v-if="$route.name === 'TopPage'"/>
        </div>
        <!-- スマホ版 -->
        <div class="max-w-1200-388" style="width: 100%;" v-else>
            <v-row class="flex-center">
                <a href="#" @click.prevent="goToTopPage">
                    <img :src="require('@/assets/kaeru.svg')" class="w-320-320"/>
                </a>
            </v-row>
            <v-spacer class="spacing-h-20-32"/>
            <v-row class="footer-links flex-center-x font-14-14">
                <a href="/terms" class="footer-link">利用規約</a>
                <a href="/conditions" class="footer-link">試算条件</a>
            </v-row>
            <v-spacer class="spacing-h-46-46"/>
            <v-row class="flex-center">
                <a href="https://uchikara-setagaya.com/?utm_source=simulation&utm_medium=internal&utm_campaign=cpweb" rel="noopener noreferrer" target="_blank">
                    <img class="md-h-140 sm-h-24" :src="require('@/assets/footer/uchikaraFooter.svg')" />
                </a>
            </v-row>
            <v-spacer class="spacing-h-10-10"/>
            <v-row class="flex-center">
                <div class="font-16-12 text-center">
                    <p>家庭の脱炭素化を支援する</p>
                    <p>補助金・助成制度をご紹介しています。</p>
                </div>
            </v-row>
            <v-spacer class="spacing-h-24-24"/>
            <v-row class="font-14-10 flex-center">
                ©UCHIKARA All Rights Reserved.
            </v-row>
            <v-spacer class="spacing-h-80-80"/>
            <v-spacer class="spacing-h-80-80" v-if="$route.name === 'TopPage'"/>
        </div>
    </v-container>
</template>

<script setup>
import { useDisplay } from 'vuetify'
import { useRouter } from 'vue-router'

const { smAndDown } = useDisplay()
const isSm = smAndDown
const router = useRouter()

function goToTopPage() {
  router.push('/')
}
</script>